<template>
    <div class="layout-header">
        <img src="../assets/images/Bloomキャリア登録logo2.svg"/>
        <h2 class="mb-30 mt-3">{{header}}</h2>
    </div>
</template>

<script>
export default {
  name: 'LogoComponent',
  props: {
    header: {
        type: String,
        required: true
    }
  }
};
</script>

<style scoped>
.layout-header {
  text-align: center;
}
a {
  text-decoration: underline;
}

h2 {
  color: #000000;
  font-family: 'Inter';
}
</style>
